(function () {
  var STORAGE_KEY = 'crc-color-mode';

  function getStoredMode() {
    return localStorage.getItem(STORAGE_KEY);
  }

  function getSystemDark() {
    return !!(window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches);
  }

  function isDark() {
    var mode = getStoredMode();
    if (mode === 'light') return false;
    if (mode === 'dark') return true;
    return getSystemDark();
  }

  function applyTheme(mode) {
    var dark;

    if (mode === 'light') {
      dark = false;
    } else if (mode === 'dark') {
      dark = true;
    } else {
      dark = getSystemDark();
    }

    document.documentElement.classList.toggle('crc-theme-dark', dark);

    if (mode === 'light' || mode === 'dark') {
      document.documentElement.setAttribute('data-crc-color-mode', mode);
    } else {
      document.documentElement.removeAttribute('data-crc-color-mode');
    }

    updateToggleUI(dark);
  }

  function updateToggleUI(dark) {
    var btn = document.querySelector('[data-crc-theme-toggle]');
    if (!btn) return;

    var sun = btn.querySelector('.coast-range-theme-toggle__icon--sun');
    var moon = btn.querySelector('.coast-range-theme-toggle__icon--moon');

    if (sun) sun.hidden = !dark;
    if (moon) moon.hidden = dark;

    btn.setAttribute('aria-label', dark ? 'Switch to light mode' : 'Switch to dark mode');
    btn.setAttribute('aria-pressed', dark ? 'true' : 'false');
    btn.setAttribute('title', dark ? 'Light mode' : 'Dark mode');
  }

  function mountToggle() {
    var template = document.getElementById('crc-theme-toggle-template');
    var icons = document.querySelector('.header__icons');

    if (!template || !icons || icons.querySelector('[data-crc-theme-toggle]')) {
      updateToggleUI(isDark());
      return;
    }

    var cart = icons.querySelector('.header__icon--cart, #cart-icon-bubble');
    var node = template.content.cloneNode(true);

    if (cart) {
      icons.insertBefore(node, cart);
    } else {
      icons.appendChild(node);
    }

    var btn = icons.querySelector('[data-crc-theme-toggle]');
    if (!btn) return;

    updateToggleUI(isDark());

    btn.addEventListener('click', function () {
      var nextMode = isDark() ? 'light' : 'dark';
      localStorage.setItem(STORAGE_KEY, nextMode);
      applyTheme(nextMode);
    });
  }

  window.CRCTheme = {
    applyTheme: applyTheme,
    isDark: isDark,
    getStoredMode: getStoredMode
  };

  if (window.matchMedia) {
    window.matchMedia('(prefers-color-scheme: dark)').addEventListener('change', function () {
      var mode = getStoredMode();
      if (!mode) {
        applyTheme('system');
      }
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', mountToggle);
  } else {
    mountToggle();
  }
})();
